import {
  AuditOutlined,
  BarChartOutlined,
  CalendarOutlined,
  CarOutlined,
  CloudServerOutlined,
  DesktopOutlined,
  DollarOutlined,
  GiftOutlined,
  GoldOutlined,
  HomeOutlined,
  LogoutOutlined,
  PictureOutlined,
  SelectOutlined,
  SettingOutlined,
  ShopOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
  UserOutlined,
  BarcodeOutlined,
  BuildOutlined,
  SlidersOutlined,
  OneToOneOutlined,
  EuroCircleOutlined,
  AppstoreOutlined,
  NotificationOutlined,
  PhoneOutlined,
  MessageOutlined,
  ScheduleOutlined,
  NodeIndexOutlined,
  LineChartOutlined,
  KeyOutlined,
  MedicineBoxOutlined,
  IssuesCloseOutlined,
  CheckCircleOutlined,
  AccountBookOutlined,
  FlagOutlined,
  LaptopOutlined,
  Loading3QuartersOutlined,
  BankOutlined,
  PercentageOutlined,
  ExperimentOutlined,
} from "@ant-design/icons";
import { Layout, Menu, notification } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import {
  IoAirplane,
  IoAlertOutline,
  IoApertureOutline,
  IoBagAddOutline,
  IoBoatOutline,
  IoCashOutline,
  IoCheckboxOutline,
  IoCheckmarkCircle,
  IoCheckmarkCircleOutline,
  IoCog,
  IoDocument,
  IoDocumentOutline,
  IoExpandOutline,
  IoImage,
  IoImageOutline,
  IoPaperPlane,
  IoSparkles,
  IoSparklesOutline,
  IoStar,
  IoStarOutline,
  IoStorefront,
  IoStorefrontOutline,
} from "react-icons/io5";
import SubMenu from "antd/es/menu/SubMenu";
import { logoutAdmin } from "../actions/AuthAction";
import { isPermitted } from "../utils/PermissionManager";
import { FiLoader } from "react-icons/fi";
import { BsCheck2Square, BsCurrencyDollar, BsListCheck } from "react-icons/bs";
import { BiDollarCircle, BiEuro, BiGridHorizontal } from "react-icons/bi";
import { MdCurrencyYuan, MdDisabledVisible } from "react-icons/md";
//   import { sidebarItems } from "../utils/Sidebars";
const { Sider } = Layout;

export default function SideMenu(props) {
  const dispatch = useDispatch();
  const location = useLocation();
  const path = location.pathname;
  const roles = useSelector((state) => state.auth.profile?.roles);
  const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
      message: message,
      description: description,
    });
  };

  const menuStyle = {
    fontSize: "14px",
    width: "18px",
  };

  return (
    <Menu
      theme="light"
      mode="inline"
      defaultSelectedKeys={[path.toString()]}
      defaultOpenKeys={["accounts"]}
      style={{
        paddingBottom: 64,
      }}
    >
      <Menu.Item key={"/"} icon={<HomeOutlined style={menuStyle} />}>
        <Link to={"/"}>Dashboard</Link>
      </Menu.Item>

      {isPermitted(roles, ["super_admin"]) && (
        <Menu.Item key={"/customers"} icon={<TeamOutlined style={menuStyle} />}>
          <Link to={"/customers"}>Customers</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, ["admin", "cn_purchase"]) && (
        <Menu.Item key={"/chat"} icon={<MessageOutlined style={menuStyle} />}>
          <Link to={"/chat"}>CRM Chat</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, [
        "admin",
        "bd_purchase",
        "cn_purchase",
        "china_basic",
        "china_crm",
        "china_purchase",
        "china_admin",
        "order",
      ]) && (
          <Menu.Item key={"/orders"} icon={<GoldOutlined style={menuStyle} />}>
            <Link to={"/orders"}>Orders</Link>
          </Menu.Item>
        )}
      {isPermitted(roles, ["admin"]) && (
        <Menu.Item
          key={"/sea-orders"}
          icon={<IoBoatOutline style={menuStyle} />}
        >
          <Link to={"/sea-orders"}>Sea</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, ["super_admin", "marketplace"]) && (
        <SubMenu
          key="marketplace"
          icon={<ShopOutlined style={menuStyle} />}
          title="Marketplace"
        >
          <Menu.Item
            key={"/marketplace/stores"}
            icon={<BankOutlined style={menuStyle} />}
          >
            <Link to={"/marketplace/stores"}>Stores</Link>
          </Menu.Item>
          <Menu.Item
            key={"/marketplace/suppliers"}
            icon={<MessageOutlined style={menuStyle} />}
          >
            <Link to={"/marketplace/suppliers"}>Suppliers</Link>
          </Menu.Item>
          <Menu.Item
            key={"/marketplace/categories"}
            icon={<AppstoreOutlined style={menuStyle} />}
          >
            <Link to={"/marketplace/categories"}>Categories</Link>
          </Menu.Item>
          <Menu.Item
            key={"/marketplace/products"}
            icon={<GoldOutlined style={menuStyle} />}
          >
            <Link to={"/marketplace/products"}>Products</Link>
          </Menu.Item>
        </SubMenu>
      )}

      {isPermitted(roles, ["admin", "china_crm"]) && (
        <SubMenu
          key="china-crm"
          icon={<IoBagAddOutline style={menuStyle} />}
          title="China CRM"
        >
          <Menu.Item
            key={"/china-crm/chat"}
            icon={<MessageOutlined style={menuStyle} />}
          >
            <Link to={"/china-crm/chat"}>Chat</Link>
          </Menu.Item>
          <Menu.Item
            key={"/china-crm/slow-orders"}
            icon={<MdDisabledVisible style={menuStyle} />}
          >
            <Link to={"/china-crm/slow-orders"}>Slow Orders</Link>
          </Menu.Item>
          <Menu.Item
            key={"/china-crm/supplier-response"}
            icon={<IoStorefrontOutline style={menuStyle} />}
          >
            <Link to={"/china-crm/supplier-response"}>Supplier Response</Link>
          </Menu.Item>
          <Menu.Item
            key={"/china-crm/purchase-center"}
            icon={<AppstoreOutlined style={menuStyle} />}
          >
            <Link to={"/china-crm/purchase-center"}>Purchase Center</Link>
          </Menu.Item>
          <Menu.Item
            key={"/china-crm/skyone-purchase"}
            icon={<MedicineBoxOutlined style={menuStyle} />}
          >
            <Link to={"/china-crm/skyone-purchase"}>SkyOne Purchase</Link>
          </Menu.Item>
          {/* <Menu.Item
            key={"/china-crm/qc"}
            icon={<ExperimentOutlined style={menuStyle} />}
          >
            <Link to={"/china-crm/qc"}>QC</Link>
          </Menu.Item> */}
          <Menu.Item
            key={"/china-crm/qc-customer"}
            icon={<ScheduleOutlined style={menuStyle} />}
          >
            <Link to={"/china-crm/qc-customer"}>Customer Qc</Link>
          </Menu.Item>

          <Menu.Item
            key={"/china-crm/support"}
            icon={<PhoneOutlined style={menuStyle} />}
          >
            <Link to={"/china-crm/support"}>Support</Link>
          </Menu.Item>
        </SubMenu>
      )}

      {isPermitted(roles, [
        "admin",
        "bd_purchase",
        "cn_purchase",
        "china_purchase",
        "china_admin",
      ]) && (
          <Menu.Item
            key={"/skyone-purchase"}
            icon={<MedicineBoxOutlined style={menuStyle} />}
          >
            <Link to={"/skyone-purchase"}>SkyOne Purchase</Link>
          </Menu.Item>
        )}

      {isPermitted(roles, [
        "admin",
        "bd_purchase",
        "cn_purchase",
        "china_purchase",
        "china_admin",
      ]) && (
          <SubMenu
            key="purchase-v4"
            icon={<IoBagAddOutline style={menuStyle} />}
            title="Purchase"
          >
            {isPermitted(roles, ["admin",
              "bd_purchase",
              "cn_purchase",
              "china_purchase",
              "china_admin",]) && (
                <Menu.Item
                  key={"/v4/supplier-response"}
                  icon={<IoStorefrontOutline style={menuStyle} />}
                >
                  <Link to={"/v4/supplier-response"}>Supplier Response</Link>
                </Menu.Item>
              )}
            {isPermitted(roles, ["super_admin", "bd_purchase"]) && (
              <Menu.Item
                key={"/v4/purchase-approval-center"}
                icon={<IoCheckmarkCircleOutline style={menuStyle} />}
              >
                <Link to={"/v4/purchase-approval-center"}>Approval Center</Link>
              </Menu.Item>
            )}
            {isPermitted(roles, ["super_admin"]) && (
              <Menu.Item
                key={"/v4/confirmation-center"}
                icon={<IoCheckboxOutline style={menuStyle} />}
              >
                <Link to={"/v4/confirmation-center"}>Confirmation Center</Link>
              </Menu.Item>
            )}
            {isPermitted(roles, [
              "admin",
              "bd_purchase",
              "cn_purchase",
              "china_purchase",
              "china_admin",
            ]) && (
                <Menu.Item
                  key={"/v4/purchase-center"}
                  icon={<AppstoreOutlined style={menuStyle} />}
                >
                  <Link to={"/v4/purchase-center"}>Purchase Center</Link>
                </Menu.Item>
              )}
            {isPermitted(roles, [
              "admin",
              "cn_purchase",
              "china_purchase",
              "china_admin",
            ]) && (
                <Menu.Item
                  key={"/supplier-confirmation"}
                  icon={<IoCheckmarkCircleOutline style={menuStyle} />}
                >
                  <Link to={"/supplier-confirmation"}>Supplier Confirmation</Link>
                </Menu.Item>
              )}
            {isPermitted(roles, ["admin", "china_admin"]) && (
              <Menu.Item
                key={"/auto-purchase-verification"}
                icon={<BsCheck2Square style={menuStyle} />}
              >
                <Link to={"/auto-purchase-verification"}>Auto Verification</Link>
              </Menu.Item>
            )}
            {isPermitted(roles, ["admin", "china_admin"]) && (
              <Menu.Item
                key={"/purchase-payment-confirmation"}
                icon={<BiDollarCircle style={menuStyle} />}
              >
                <Link to={"/purchase-payment-confirmation"}>Payment Sheet</Link>
              </Menu.Item>
            )}
            {isPermitted(roles, ["admin", "china_admin"]) && (
              <Menu.Item
                key={"/auto-payment"}
                icon={<BiEuro style={menuStyle} />}
              >
                <Link to={"/auto-payment"}>Auto Payment</Link>
              </Menu.Item>
            )}
          </SubMenu>
        )}

      {isPermitted(roles, [
        "admin",
        "bd_purchase",
        "cn_purchase",
        "china_admin",
      ]) && (
          <SubMenu
            key="tracking"
            icon={<BarcodeOutlined style={menuStyle} />}
            title="Tracking"
          >
            {isPermitted(roles, [
              "admin",
              "bd_purchase",
              "cn_purchase",
              "china_admin",
            ]) && (
                <Menu.Item
                  key={"/tracking"}
                  icon={<BarcodeOutlined style={menuStyle} />}
                >
                  <Link to={"/tracking"}>Manual Tracking</Link>
                </Menu.Item>
              )}
            {isPermitted(roles, ["admin", "tracking", "china_admin"]) && (
              <Menu.Item
                key={"/auto-tracking"}
                icon={<KeyOutlined style={menuStyle} />}
              >
                <Link to={"/auto-tracking"}>Auto Tracking</Link>
              </Menu.Item>
            )}
          </SubMenu>
        )}

      {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
        <Menu.Item key={"/sorting"} icon={<BsListCheck style={menuStyle} />}>
          <Link to={"/sorting"}>Sorting</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, ["admin", "shipment"]) && (
        <SubMenu
          key="shipping-charges"
          icon={<BsCurrencyDollar style={menuStyle} />}
          title="Shipping Charges"
        >
          {isPermitted(roles, ["admin", "shipment"]) && (
            <Menu.Item
              key={"/shipping-categories"}
              icon={<BsListCheck style={menuStyle} />}
            >
              <Link to={"/shipping-categories"}>Categories</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["admin", "shipment"]) && (
            <Menu.Item
              key={"/shipping-charges"}
              icon={<BsCurrencyDollar style={menuStyle} />}
            >
              <Link to={"/shipping-charges"}>Charges</Link>
            </Menu.Item>
          )}
        </SubMenu>
      )}
      {isPermitted(roles, ["super_admin"]) && (
        <Menu.Item
          key="/shipping-category"
          icon={
            <BiGridHorizontal style={{ fontSize: "14px", width: "18px" }} />
          }
        >
          <Link to={"/shipping-category"}>Shipping Category</Link>
        </Menu.Item>
      )}
      {/* {isPermitted(roles, ["admin", "shipment"]) && (
        <Menu.Item key={"/qc"} icon={<ExperimentOutlined style={menuStyle} />}>
          <Link to={"/qc"}>QC</Link>
        </Menu.Item>
      )} */}
      {isPermitted(roles, ["admin", "shipment", "china_admin"]) && (
        <Menu.Item
          key={"/qc-customer"}
          icon={<ScheduleOutlined style={menuStyle} />}
        >
          <Link to={"/qc-customer"}>Customer Qc</Link>
        </Menu.Item>
      )}
      {isPermitted(roles, ["super_admin", "accountant"]) && (
        <Menu.Item
          key={"/cash-counter"}
          icon={<DollarOutlined style={menuStyle} />}
        >
          <Link to={"/cash-counter"}>Cash Counter</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, ["super_admin"]) && (
        <Menu.Item key={"/coupons"} icon={<GiftOutlined style={menuStyle} />}>
          <Link to={"/coupons"}>Coupons</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, ["super_admin"]) && (
        <Menu.Item
          key={"/campaigns"}
          icon={<NotificationOutlined style={menuStyle} />}
        >
          <Link to={"/campaigns"}>Campaigns</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, ["super_admin"]) && (
        <Menu.Item
          key={"/airport-damaged"}
          icon={<IoAirplane style={menuStyle} />}
        >
          <Link to={"/airport-damaged"}>Airport Damaged</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, ["admin", "support", "china_admin"]) && (
        <Menu.Item
          key={"/support"}
          icon={<MessageOutlined style={menuStyle} />}
        >
          <Link to={"/support"}>Support</Link>
        </Menu.Item>
      )}
      {isPermitted(roles, ["admin", "support", "china_admin"]) && (
        <Menu.Item
          key={"/complains"}
          icon={<IoAlertOutline style={menuStyle} />}
        >
          <Link to={"/complains"}>Complains</Link>
        </Menu.Item>
      )}

      {/* {isPermitted(roles, ["super_admin"]) && (
        <Menu.Item key={"/tasks"} icon={<ScheduleOutlined style={menuStyle} />}>
          <Link to={"/tasks"}>Task Manager</Link>
        </Menu.Item>
      )} */}

      {isPermitted(roles, ["super_admin", "accountant"]) && (
        <Menu.Item key={"/payments"} icon={<IoCashOutline style={menuStyle} />}>
          <Link to={"/payments"}>Payments</Link>
        </Menu.Item>
      )}
      {isPermitted(roles, ["super_admin", "accountant"]) && (
        <Menu.Item key={"/point"} icon={<IoStarOutline style={menuStyle} />}>
          <Link to={"/point"}>Point</Link>
        </Menu.Item>
      )}
      {isPermitted(roles, ["super_admin", "master_admin"]) && (
        <Menu.Item
          key={"/b2c-recharge"}
          icon={<DollarOutlined style={menuStyle} />}
        >
          <Link to={"/b2c-recharge"}>B2C Recharge</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, ["super_admin", "accountant"]) && (
        <SubMenu key="refund" icon={<LaptopOutlined />} title="Refund Hub">
          {isPermitted(roles, ["super_admin", "accountant"]) && (
            <Menu.Item
              key={"/pending-refunds"}
              icon={<Loading3QuartersOutlined style={menuStyle} />}
            >
              <Link to={"/pending-refunds"}>Pending Refund</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["super_admin", "accountant"]) && (
            <Menu.Item
              key={"/ready-refunds"}
              icon={<CheckCircleOutlined style={menuStyle} />}
            >
              <Link to={"/ready-refunds"}>Ready to Refund</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["super_admin", "accountant"]) && (
            <Menu.Item
              key={"/refund-history"}
              icon={<NodeIndexOutlined style={menuStyle} />}
            >
              <Link to={"/refund-history"}>Refund History</Link>
            </Menu.Item>
          )}
        </SubMenu>
      )}

      {isPermitted(roles, ["super_admin", "accountant"]) && (
        <SubMenu key="reports" icon={<BarChartOutlined />} title="Reports">
          {isPermitted(roles, ["super_admin", "accountant"]) && (
            <Menu.Item
              key={"/delivery-payment-report"}
              icon={<CarOutlined style={menuStyle} />}
            >
              <Link to={"/delivery-payment-report"}>
                Delivery Payment Report
              </Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["super_admin", "accountant"]) && (
            <Menu.Item
              key={"/rmb-transaction-report"}
              icon={<MdCurrencyYuan style={menuStyle} />}
            >
              <Link to={"/rmb-transaction-report"}>
                RMB Transaction Report
              </Link>
            </Menu.Item>
          )}
        </SubMenu>
      )}

      {isPermitted(roles, ["admin", "marketing"]) && (
        <Menu.Item key={"/gallery"} icon={<IoImageOutline style={menuStyle} />}>
          <Link to={"/gallery"}>Gallery</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, ["admin", "marketing"]) && (
        <Menu.Item
          key={"/bulk-notification"}
          icon={<NotificationOutlined style={menuStyle} />}
        >
          <Link to={"/bulk-notification"}>Bulk Notification</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, ["super_admin"]) && (
        <SubMenu key="settings" icon={<SettingOutlined />} title="Settings">
          <Menu.Item
            key={"/settings/rates"}
            icon={<EuroCircleOutlined style={menuStyle} />}
          >
            <Link to={"/settings/rates"}>Rates & Margin</Link>
          </Menu.Item>
          <Menu.Item
            key={"/settings/shipping-charges"}
            icon={<CarOutlined style={menuStyle} />}
          >
            <Link to={"/settings/shipping-charges"}>Shipping Charges</Link>
          </Menu.Item>
        </SubMenu>
      )}

      {isPermitted(roles, ["super_admin"]) && (
        <Menu.Item
          key="/admins"
          icon={
            <UsergroupAddOutlined style={{ fontSize: "14px", width: "18px" }} />
          }
        >
          <Link to={"/admins"}>Admins</Link>
        </Menu.Item>
      )}

      <Menu.Item
        key="/SettingOutlined "
        icon={<UserOutlined style={{ fontSize: "14px", width: "18px" }} />}
      >
        <Link to={"/profile"}>Profile</Link>
      </Menu.Item>
      <Menu.Item
        key="/logout"
        onClick={() => {
          dispatch(logoutAdmin(() => { }));
          openNotificationWithIcon(
            "success",
            "Success",
            "Logged out successfully",
          );
        }}
        icon={<LogoutOutlined style={{ fontSize: "16px", width: "18px" }} />}
      >
        Logout
      </Menu.Item>
    </Menu>
  );
}
